import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import tw from "twin.macro";
import Hero from "../hero";
import ContactList from "./contact-list";

import Tabs from "../tabs";
import Corrections from "../corrections";

const ContactContainer = tw.div`container mx-auto`;

const ContactContent = () => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "contact-banner.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  const tabs = [
    { label: "Organizational Contacts", active: true, to: "/contact" },
    { label: "Contact Directory", active: false, to: "/contacts-directory" }
  ];

  return (
    <>
      <Hero imgQuery={data.file.childImageSharp.fluid}>
        Organizational Contacts
      </Hero>
      <div tw="bg-gray-100">
        <div tw="container mx-auto">
          <Tabs tabs={tabs} />
        </div>
      </div>
      <ContactContainer>
        <ContactList />
      </ContactContainer>
      <Corrections />
    </>
  );
};

export default ContactContent;
